// axios请求
import instance from './header.js'

// ✅ 新增：统一格式化错误
const formatError = (err) => {
  // 如果 err 是 undefined 或 null，返回一个标准错误
  if (!err) return new Error('网络请求失败')

  // 如果已经是普通 Error，直接返回
  if (err instanceof Error && !err.response) return err

  // 提取 axios 错误中的有效信息，避免循环引用
  return {
    status: err.response?.status || 0,
    message: err.message || '请求失败',
    data: err.response?.data || null,
    config: {
      url: err.config?.url,
      method: err.config?.method
    }
  }
}

const request = class {
  constructor(url, arg) {
    this.url = url
    this.arg = arg
  }

  modepost() {
    return new Promise((resolve, reject) => {
      instance.post(this.url, this.arg)
        .then(res => resolve(res))
        .catch(err => reject(formatError(err)))  // ✅ 格式化后 reject
    })
  }

  modedel() {
    return new Promise((resolve, reject) => {
      instance.delete(this.url, this.arg)
        .then(res => resolve(res))
        .catch(err => reject(formatError(err)))
    })
  }

  modeget() {
    return new Promise((resolve, reject) => {
      instance.get(this.url)
        .then(res => resolve(res))
        .catch(err => reject(formatError(err)))
    })
  }

  modeput() {
    return new Promise((resolve, reject) => {
      instance.put(this.url, this.arg)
        .then(res => resolve(res))
        .catch(err => reject(formatError(err)))
    })
  }
}

export default request